import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { PairWikiCategory } from "../../context/formContext/types";
import { WikiCategory } from "../../pages/FormSections/AgeLocationSelect";
import AssetManager from "../AssetManager";

const WikiCategoryCard: React.FC<WikiCategoryCardProps> = ({
  wikiCategories,
  pairWikiCategory,
  onClick,
}) => {
  const { i18n } = useTranslation();

  const [details, setDetails] = useState<WikiCardDetails>(
    getCardDetailsForWikiCategory(pairWikiCategory.categoryID)
  );

  useEffect(() => {
    setDetails(getCardDetailsForWikiCategory(pairWikiCategory.categoryID));

    return () => {};
  }, [pairWikiCategory]);

  function getCardDetailsForWikiCategory(categoryId: number): WikiCardDetails {
    const cat = wikiCategories.find((c) => c.categoryId === categoryId);

    const content = i18n.t(cat?.wikiCategoryNameKey ?? "");

    return {
      content: content,
      iconUrl: `/wiki_category_${categoryId}.svg`,
    };
  }

  return (
    <div className="wiki-list-item" onClick={onClick}>
      <img
        src={AssetManager.getAsset(details.iconUrl)}
        alt="wiki category icon"
      />
      <span className="wiki-category-name">{details.content}</span>
    </div>
  );
};

export default WikiCategoryCard;

export interface WikiCategoryCardProps {
  wikiCategories: WikiCategory[];
  pairWikiCategory: PairWikiCategory;
  onClick: () => void;
}

export interface WikiCardDetails {
  content: string;
  iconUrl: string;
}
